<template>
  <filebox-dashboard
    :icons="icons"
    :myFiles="myFiles"
    :companyFiles="companyFiles"
    :loadingMyFiles="loadingMyFiles"
    :loadingCompanyFiles="loadingCompanyFiles">
  </filebox-dashboard>
</template>

<script>
import { mapState } from 'vuex';
import FileboxDashboard from '@/components/filebox/FileboxDashboard';

export default {
  name: 'FileboxContainer',
  components: {
    FileboxDashboard,
  },
  computed: {
    ...mapState(['icons']),
    ...mapState('filebox', ['myFiles', 'companyFiles', 'loadingMyFiles', 'loadingCompanyFiles']),
  },
  mounted() {
    this.$store.dispatch('filebox/getMyFiles');
    this.$store.dispatch('filebox/getCompanyFiles');
  },
};
</script>




// WEBPACK FOOTER //
// FileboxContainer.vue?314b6973